var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNetworkIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "data-reactroot": "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z",
    undefined: 1
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M12 22C14.2091 22 16 17.5228 16 12C16 6.47715 14.2091 2 12 2C9.79086 2 8 6.47715 8 12C8 17.5228 9.79086 22 12 22Z",
    undefined: 1
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1,
    stroke: "currentColor",
    d: "M12 22C14.2091 22 16 17.5228 16 12C16 6.47715 14.2091 2 12 2C9.79086 2 8 6.47715 8 12C8 17.5228 9.79086 22 12 22Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1,
    stroke: "currentColor",
    d: "M21.54 15H2.46002"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1,
    stroke: "currentColor",
    d: "M2.46002 9H21.54"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNetworkIcon);
export default __webpack_public_path__ + "static/media/NetworkIcon.738eed862f52e31c661e36adcb4bf9ee.svg";
export { ForwardRef as ReactComponent };